<template> 
    <div v-if="showComponent">
        <div class="modal fade show modal-disclaimer" style="display:block;" id="disclaimer-modal" tabindex="-1" role="dialog" aria-hidden="true" v-if="showDisclaimer">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-html="disclaimerContent.title[0].value"></h5>
                    </div>
                    <div class="modal-body" v-html="disclaimerContent.body[0].value"></div>
                    <button v-on:click="disclaimerShown" type="button" class="btn btn-primary btn-chevron-right modal-close">Agree</button>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'Disclaimer',
        props: {
            timeline: {
                value: "false",
                required: true,
                type: String
            }
        },
        computed: {
            showComponent(){
                let result = null;
                if ((this.timeline === "true") && (this.hasIndexRedirect) ) {
                    result = this.disclaimerContent;
                } else if (this.timeline === "false") {
                    result = this.disclaimerContent;
                }
                return result;
            },
            hasIndexRedirect(){
                return this.$store.getters.getIndexRedirect;
            },
            disclaimerContent() {
                return this.$store.getters.getDisclaimerContent;
            },
            disclaimerHasBeenSeen(){
                return this.$store.getters.getDisclaimerStatus; 
            },
            getLocalStorageDisclaimer(){
                var disclaimer = window.localStorage.getItem('disclaimer');
                
                return disclaimer !== null;
            },
            showDisclaimer(){
                /* if disclaimer has been disabled via config */
                if (this.getLocalStorageDisclaimer === false){
                    /* if disclaimer has already been seen */
                    if (this.disclaimerHasBeenSeen === false){
                        return true && this.isIpad;
                    } else {
                        return false; 
                    }
                } else {
                    return false; 
                }
            }
        },
        methods: {
            disclaimerShown() {
               this.$store.dispatch('setDisclaimerStatus');
            }
        }
    }

</script>